// extracted by mini-css-extract-plugin
export default {"tabs":"Skills_tabs__pmPmF","tab":"Skills_tab__mPqgr","active":"Skills_active__CSXm5","pills":"Skills_pills__49Yry","pill":"Skills_pill__W+HRl"};